import React, { useState } from "react";
import backgroundImage from "../assets/img/partnerimage.png";
import backgroundImageheader from "../assets/img/partnerheader.png";
import SEO from "./SEO";
import { useEffect } from "react";
import ReactGA  from "react-ga4";
const Partner = () => {
	// Add state for form data and validation
	const [formData, setFormData] = useState({
		fullName: "",
		email: "",
		phoneNumber: "",
		organizationName: "",
		specialization: "",
		availability: "",
		acceptGuidelines: false,
	});
	const [errors, setErrors] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitMessage, setSubmitMessage] = useState("");

	// Validation functions
	const validateEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};

	const validatePhone = (phone) => {
		const phoneRegex = /^\+?[\d\s-]{10,}$/;
		return phoneRegex.test(phone);
	};

	const validateForm = () => {
		const newErrors = {};

		if (!formData.fullName.trim()) {
			newErrors.fullName = "Full name is required";
		}

		if (!formData.email) {
			newErrors.email = "Email is required";
		} else if (!validateEmail(formData.email)) {
			newErrors.email = "Please enter a valid email";
		}

		if (!formData.phoneNumber) {
			newErrors.phoneNumber = "Phone number is required";
		} else if (!validatePhone(formData.phoneNumber)) {
			newErrors.phoneNumber = "Please enter a valid phone number";
		}

		if (!formData.organizationName.trim()) {
			newErrors.organizationName = "Organization name is required";
		}

		if (!formData.specialization.trim()) {
			newErrors.specialization = "Specialization is required";
		}

		if (!formData.availability.trim()) {
			newErrors.availability = "Available services information is required";
		}

		if (!formData.acceptGuidelines) {
			newErrors.acceptGuidelines = "You must accept the guidelines";
		}

		return newErrors;
	};

	// Handle input changes
	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: type === "checkbox" ? checked : value,
		}));
		// Clear error when user types
		if (errors[name]) {
			setErrors((prev) => ({ ...prev, [name]: "" }));
		}
	};

	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();

		// Validate form
		const newErrors = validateForm();
		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors);
			return;
		}

		setIsSubmitting(true);
		try {
			const response = await fetch(
				"https://office.synergycarefoundation.org/api/partnership",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(formData),
				}
			);

			if (response.ok) {
				setSubmitMessage(
					"Thank you for your partnership application! We'll be in touch soon."
				);
				setFormData({
					fullName: "",
					email: "",
					phoneNumber: "",
					organizationName: "",
					specialization: "",
					availability: "",
					acceptGuidelines: false,
				});
			} else {
				setSubmitMessage("Something went wrong. Please try again.");
			}
		} catch (error) {
			console.error("Error submitting form:", error);
			setSubmitMessage("Failed to submit application. Please try again later.");
		} finally {
			setIsSubmitting(false);
		}
	};
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/partner",
      title: "Partner with Us | SynergyCare Foundation",
    });
  });

	return (
		<div className=''>
			<SEO
				title='Partner with Us | SynergyCare Foundation'
				description='Join SynergyCare Foundation as a healthcare provider and help connect under-served patients with quality healthcare services.'
				name='SynergyCare Foundation'
				type=''
			/>
			<div
				style={{
					backgroundImage: `url(${backgroundImageheader})`,
				}}
				className='text-white bg-no-repeat bg-fixed bg-cover bg-center'>
				<div className='text-center lg:pt-40 pt-32 pb-16 max-w-[768px] mx-auto w-[90%] space-y-5'>
					<h1 className='text-white lg:text-[72px]/[79px] text-[40px]/[67px] lg:tracking-[-2px] tracking-[-1.72px] font-medium'>
						Partner with Us
					</h1>

					<p className=' text-white md:text-2xl/10 text-lg/6'>
						Join SynergyCare Foundation as a healthcare provider and help
						connect underserved patients with quality healthcare services.
					</p>
				</div>
			</div>
			<div className='flex gap-20 justify-center lg:items-start items-center lg:flex-row  flex-col max-w-[1440px] w-[90%] mx-auto lg:py-20 py-10 lg:text-left text-center'>
				<h3 className='text-[#11112D] font-medium tracking-[-1px] md:text-[56px]/[76px] text-[32px]/10 max-w-[457px] w-full'>
					Join Our Network of Compassionate Providers.
				</h3>
				<div className='max-w-[627px] w-full  text-[#11112D] text-lg/10 font-light'>
					<p className=''>
						SynergyCare Foundation invites healthcare providers to partner with
						us in creating equitable access to quality care. By joining our
						network, you'll connect with patients who need your services while
						making a measurable difference in under-served communities.
					</p>
					<h6 className='text-2xl/10 font-medium  mt-5 mb-2'>
						Benefits of Partnership
					</h6>
					<ul className='space-y-2 list-disc list-inside'>
						<li className='text-[16px] '>
							Expand your reach to patients in need
						</li>

						<li className='text-[16px] '>
							Collaborate on impactful healthcare initiatives.
						</li>

						<li className='text-[16px] '>
							Be recognized as a champion for healthcare equity.
						</li>
					</ul>
				</div>
			</div>
			<div className='max-w-[1440px] w-[90%] mx-auto rounded-[20px]'>
				<div
					style={{
						backgroundImage: `url(${backgroundImage})`,
					}}
					className='rounded-[20px] py-8 bg-cover bg-fixed bg-center bg-no-repeat'>
					<div className='lg:w-[90%] w-[95%] mx-auto'>
						<h2 className='text-white lg:text-[64px]/[80px] text-[32px]/[56px] font-medium lg:text-left text-center md:tracking-[-3px] tracking-[-1.55px]'>
							Benefits of Partnership
						</h2>
						<div className='flex gap-5 justify-center lg:flex-row lg:items-stretch items-center  flex-col w-[100%] lg:pt-[180px] pt-10'>
							<div className='flex flex-col gap-10 lg:w-[30%] md:w-[70%] w-[100%] bg-[#FFCF4E] rounded-[30px] p-5'>
								<h4 className='w-[80%] text-[#025788] md:text-[32px]/[42px] text-[28px]/[38px] font-medium'>
									Complete the Partnership Form
								</h4>
								<p className='text-[#025788] md:text-2xl/8 text-base/6'>
									Fill out the form below with your information.
								</p>
							</div>
							<div className='flex flex-col gap-10 lg:w-[30%] md:w-[70%] w-[100%]  bg-transparent border-[3px]  rounded-[30px] p-5'>
								<h4 className='w-[90%] text-[#FFFFFF] md:text-[32px]/[42px] text-[28px]/[38px] font-medium'>
									Schedule an Introductory Meeting
								</h4>
								<p className='text-[#FFFFFF] md:text-2xl/8 text-base/6'>
									We'll connect to discuss how we can collaborate.
								</p>
							</div>
							<div className='flex flex-col gap-10 lg:w-[30%] md:w-[70%] w-[100%] bg-transparent border-[3px] rounded-[30px] p-5'>
								<h4 className='w-[50%] text-[#FFFFFF] md:text-[32px]/[42px] text-[28px]/[38px] font-medium'>
									Onboard with Us
								</h4>
								<p className='text-[#FFFFFF] md:text-2xl/8 text-base/6'>
									Gain access to tools and resources to start making an impact.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<form
				onSubmit={handleSubmit}
				className='lg:py-20 py-10 max-w-[600px] mx-auto w-[90%] space-y-10'>
				<h2 className='lg:text-[64px]/[80px] text-[32px]/[56px] font-medium  md:tracking-[-3px] tracking-[-1.55px] text-center text-[#1D1D1D]'>
					Partnership Form
				</h2>
				<div className='space-y-10'>
					<div className='relative'>
						<input
							name='fullName'
							value={formData.fullName}
							onChange={handleInputChange}
							placeholder='Full Name *'
							className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
								errors.fullName ? "border-red-500" : ""
							}`}
						/>
						{errors.fullName && (
							<p className='text-red-500 text-sm mt-1'>{errors.fullName}</p>
						)}
					</div>

					<div className='relative'>
						<input
							name='email'
							type='email'
							value={formData.email}
							onChange={handleInputChange}
							placeholder='Contact Email *'
							className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
								errors.email ? "border-red-500" : ""
							}`}
						/>
						{errors.email && (
							<p className='text-red-500 text-sm mt-1'>{errors.email}</p>
						)}
					</div>

					<div className='relative'>
						<input
							name='phoneNumber'
							value={formData.phoneNumber}
							onChange={handleInputChange}
							placeholder='Phone Number *'
							className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
								errors.phoneNumber ? "border-red-500" : ""
							}`}
						/>
						{errors.phoneNumber && (
							<p className='text-red-500 text-sm mt-1'>{errors.phoneNumber}</p>
						)}
					</div>

					<div className='relative'>
						<input
							name='organizationName'
							value={formData.organizationName}
							onChange={handleInputChange}
							placeholder='Practice/Organization Name *'
							className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
								errors.organizationName ? "border-red-500" : ""
							}`}
						/>
						{errors.organizationName && (
							<p className='text-red-500 text-sm mt-1'>
								{errors.organizationName}
							</p>
						)}
					</div>

					<div className='relative'>
						<input
							name='specialization'
							value={formData.specialization}
							onChange={handleInputChange}
							placeholder='Specialization *'
							className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
								errors.specialization ? "border-red-500" : ""
							}`}
						/>
						{errors.specialization && (
							<p className='text-red-500 text-sm mt-1'>
								{errors.specialization}
							</p>
						)}
					</div>

					<div className='relative'>
						<input
							name='availability'
							value={formData.availability}
							onChange={handleInputChange}
							placeholder='Available Services for Underserved Patients *'
							className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
								errors.availability ? "border-red-500" : ""
							}`}
						/>
						{errors.availability && (
							<p className='text-red-500 text-sm mt-1'>{errors.availability}</p>
						)}
					</div>
				</div>

				<div className='flex flex-row items-center gap-2 my-5'>
					<input
						type='checkbox'
						name='acceptGuidelines'
						checked={formData.acceptGuidelines}
						onChange={handleInputChange}
						className={`border-2 outline-none block ${
							errors.acceptGuidelines ? "border-red-500" : ""
						}`}
					/>
					<p className='text-base/5'>
						I agree to partner in accordance with the guidelines of SynergyCare
						Foundation
					</p>
					{errors.acceptGuidelines && (
						<p className='text-red-500 text-sm absolute bottom-[-20px] left-0'>
							{errors.acceptGuidelines}
						</p>
					)}
				</div>

				{submitMessage && (
					<p
						className={`text-sm ${
							submitMessage.includes("error")
								? "text-red-500"
								: "text-green-500"
						}`}>
						{submitMessage}
					</p>
				)}

				<button
					type='submit'
					disabled={isSubmitting}
					className='text-[#000000] lg:text-lg/7 text-[12px]/5 py-2.5 lg:py-5 w-full max-w-[600px] mx-auto block  bg-[#45E99E] rounded-[67px] disabled:opacity-50 disabled:cursor-not-allowed mt-5'>
					{isSubmitting ? "Submitting..." : "Submit Application"}
				</button>
			</form>
		</div>
	);
};

export default Partner;
